import React from "react";
import isString from "lodash/isString";
import loadjs from "loadjs";

import { getLabel } from "./util";
import * as caUtil from "@callApi";
import { checkSSO } from "../wea-tools/checkSSO";
import { ls } from "../wea-tools/storage";
import wm from "../wea-tools/watermark";
import WindowFunc from "../wea-tools/window";

const callApi = caUtil.callApi;

const localeKey = "e9_locale";

const constant = {
  langRegP: /(~`~`(([\d ]{1,2}[^`]{0,2000}?`~`)+[\d ]{1,2}[^`]{0,2000}?)`~`~).{0,2000}?/i,
  blank: /&nbsp;/g,
  LANG_CONTENT_PREFIX: "~`~`",
  LANG_CONTENT_SPLITTER1: "`~`",
  LANG_CONTENT_SUFFIX: "`~`~",
  LANG_INPUT_PREFIX: "__multilangpre_"
};

const getLocale = () => window[localeKey];

const getUserLanguage = () => {
  if (localStorage.login) {
    try {
      const login = JSON.parse(localStorage.login);
      if (login.langId) {
        return login.langId;
      }
      if (window[localeKey]) {
        return window[localeKey].userLanguage || 7;
      }
    } catch (error) {
      console && console.error("多语言获取失败 :(", error);
    }
  }
};

const getOs = cb => {
  if (!window.hasGetOpenClassification) {
    callApi(
      "/api/hrm/classifiedProtection/getClassificationInfo4Component",
      "GET",
      {}
    )
      .then(res => {
        if (res.status) {
          const { isOpenClassification, resourceOptionInfo } = res;
          window.localStorage.setItem(
            "resourceOptionInfo",
            JSON.stringify(resourceOptionInfo)
          );
          window.localStorage.setItem(
            "isOpenClassification",
            isOpenClassification
          );
          window.hasGetOpenClassification = true;
        }
      })
      .catch(err => {
        // window.console && window.console.log('err: ', err);
      });
  }
  callApi("/api/system/info/getOSinfo", "GET", {})
    .then(res => {
      if (res.status) {
        ls.set("getOsInfo", res);
        const {
          defaultLinkMode,
          dragColumns,
          uploadSuffixLimit,
          prohibitDownload,
          languageVersion
        } = res;
        window.localStorage.setItem("ec_open_rewrite", defaultLinkMode);
        window.localStorage.setItem("dragColumns_WeaTable", dragColumns);
        window.localStorage.setItem("uploadSuffixLimit", uploadSuffixLimit);
        window.localStorage.setItem("prohibitDownload", prohibitDownload);
        window.localStorage.setItem("languageVersion", languageVersion);
      }
      const { browserConfig } = res;
      if (browserConfig) {
        const {
          timeInterval,
          typeList,
          defaultPageSize,
          pageConfigList,
          defaultCountry
        } = browserConfig;
        // 保存浏览按钮的设置
        window.ecBrowserConfig = browserConfig;
        // 获取浏览按钮显示设置
        window.ecBrowserDisplayStyle = typeList || [];
        // 获取系统时间间隔设置
        window.ecTimePickerMinuteStep = timeInterval || 1;
        // 获取浏览按钮默认显示条数
        window.ecBrowserDisplayPageSize = defaultPageSize || 10;
        // 获取浏览按钮显示条数配置
        window.ecBrowserDisplayConfigList = pageConfigList || [];
        // 获取城市浏览框默认国家配置
        window.ecBrowserDefaultCountry = defaultCountry;
      }
      cb();
    })
    .catch(err => {
      // window.console && window.console.log('err: ', err);
    });
  // window.localStorage.removeItem("ec_open_rewrite");
};

// const overTime =(msg, timeout) => new Promise((rs, rj) => {
//   setTimeout(() => rs(msg), timeout);
// });

const isInMain = () => window.location.href.indexOf("/wui/index") > 0;

const transModeleCode = moduleCode => {
  let mod = [];
  if (Array.isArray(moduleCode)) {
    mod = [...moduleCode];
  } else if (typeof moduleCode === "string" && moduleCode.indexOf(",") > 0) {
    mod = moduleCode.split(",");
  } else {
    mod = [moduleCode];
  }
  return mod;
};

const checkModuleCode = (moduleCode, noNeedTransMod = false) => {
  // noNeedTransMod: 是否需要通过transModeleCode转一次moduleCode
  if (!moduleCode || !`${moduleCode}`) return false;
  // let mod = noNeedTransMod ? moduleCode : transModeleCode(moduleCode);
  let mod = transModeleCode(moduleCode);
  if (window[localeKey]) {
    // fix: 过滤mod 取window[localeKey].loadedModules没有的,有的直接拿lable，没有走接口
    mod = mod.filter(
      m => !window[localeKey].loadedModules.some(_m => _m === m)
    );
    if (mod.length > 0) {
      // fix: 过滤后的mod,拼接到window[localeKey].loadedModules中
      window[localeKey].loadedModules = window[localeKey].loadedModules.concat(
        mod
      );
    }
  }
  if (mod.length === 0) return false;
  return mod;
};

// 通过语言类型获取多语言标签
const getLocaleLabelByLang = (moduleCode, languageId = "") => {
  // moduleCode: 模块名 languageId:当前语音标识
  const language =
    typeof language === "string" && languageId !== ""
      ? Number(languageId)
      : languageId;
  return new Promise((rs, rj) => {
    const noNeedTransMod =
      !window[localeKey] || window[localeKey].userLanguage != language;
    // 如果当前缓存中没有window[localeKey] 或者 当前的语言类型发生改变,重置数据
    if (noNeedTransMod) {
      window[localeKey] = {
        userLanguage: language,
        loadedModules: [],
        reloadedModules: []
      };
    } else {
      // 语言类型赋值
      window[localeKey].userLanguage = language;
    }
    const mod = checkModuleCode(moduleCode, noNeedTransMod);
    let modUrl = [];
    mod.length > 0 &&
      mod.forEach(element => {
        element += "";
        element = element.toLowerCase();
        modUrl.push(`/mobile/languagelocal/${languageId}/${element}.js`);
        return element;
      });
    let loadedConut = 0;
    let callback = function(resolve, url) {
      var mod = url.slice(url.lastIndexOf("/") + 1, url.lastIndexOf("."));
      var localjsonTemp = "";
      if (!window["localjson" + mod + languageId]) {
        localjsonTemp = window["localjson" + mod];
        window["localjson" + mod + languageId] = window["localjson" + mod];
      } else {
        localjsonTemp = window["localjson" + mod + languageId];
      }
      if (Array.isArray(localjsonTemp)) {
        localjsonTemp.forEach(item => {
          if (!window[localeKey][item.type]) {
            window[localeKey][item.type] = {};
          }
          window[localeKey][item.type][item.id] = item.label;
        });
        window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
      }
      // checkMode方法已处理，不需要再处理一次
      // window[localeKey].loadedModules = window[localeKey].loadedModules.concat(
      //   mod
      // );

      loadedConut += 1;
      if (loadedConut == modUrl.length) {
        resolve();
      }
    };
    callback.bind(this);
    !mod
      ? rs()
      : modUrl.forEach(url => {
          loadjs.isDefined(url + "?v=" + localStorage["languageVersion"])
            ? loadjs.ready(url + "?v=" + localStorage["languageVersion"], () =>
                callback(rs, url)
              )
            : loadjs(
                [url + "?v=" + localStorage["languageVersion"]],
                url + "?v=" + localStorage["languageVersion"],
                {
                  success: () => {
                    callback(rs, url);
                  },
                  error: () => {
                    console && console.warn("load " + url + " fail");
                    callback(rs, url);
                  }
                }
              );
        });
    //  callApi("/api/ec/dev/locale/getLabelByModule", "GET", {
    //     moduleCode: `${mod}`,
    //     languageId: language
    //   }).then(result => {
    //     const { datas } = result;
    //     if (Array.isArray(datas)) {
    //       datas.forEach(item => {
    //         if (!window[localeKey][item.type]) {
    //           window[localeKey][item.type] = {};
    //         }
    //         window[localeKey][item.type][item.id] = item.label;
    //       });
    //       window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
    //     }
    //     window[localeKey].loadedModules = window[
    //       localeKey
    //     ].loadedModules.concat(mod);
    //     rs();
    //   });
  });
};

// 通过模块名获取多语言标签
const getLocaleLabelByCode = (
  moduleCode,
  isform = false,
  noNeedTransMod = false
) =>
  new Promise((rs, rj) => {
    // if (isform) {
    //   if (window[localeKey]) {
    //     rs();
    //     return;
    //   } else {
    //     if (window.localStorage[localeKey]) {
    //       window[localeKey] = JSON.parse(window.localStorage[localeKey]);
    //     }
    //   }
    // }
    if (!window[localeKey]) {
      window[localeKey] = {
        loadedModules: [],
        reloadedModules: []
      };
    }
    const mod = checkModuleCode(moduleCode, noNeedTransMod);
    let modUrl = [];
    mod.length > 0 &&
      mod.forEach(element => {
        element += "";
        element = element.toLowerCase();
        modUrl.push(
          `/mobile/languagelocal/${window.localStorage["languageidweaver"] ||
            7}/${element}.js`
        );
        return element;
      });
    let loadedConut = 0;
    let callback = function(resolve, url) {
      var mod = url.slice(url.lastIndexOf("/") + 1, url.lastIndexOf("."));
      var localjsonTemp = "";
      if (
        !window["localjson" + mod + window.localStorage["languageidweaver"]]
      ) {
        localjsonTemp = window["localjson" + mod];
        window["localjson" + mod + window.localStorage["languageidweaver"]] =
          window["localjson" + mod];
      } else {
        localjsonTemp =
          window["localjson" + mod + window.localStorage["languageidweaver"]];
      }
      if (Array.isArray(localjsonTemp)) {
        localjsonTemp.forEach(item => {
          if (!window[localeKey][item.type]) {
            window[localeKey][item.type] = {};
          }
          window[localeKey][item.type][item.id] = item.label;
        });
        window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
      }
      // checkMode方法已处理，不需要再处理一次
      // window[localeKey].loadedModules = window[localeKey].loadedModules.concat(
      //   mod
      // );

      loadedConut += 1;
      if (loadedConut == modUrl.length) {
        resolve();
      }
    };
    callback.bind(this);
    if (window.localStorage.ennableTrans != "1") {
      !mod
        ? rs()
        : modUrl.forEach(url => {
            loadjs.isDefined(url + "?v=" + localStorage["languageVersion"])
              ? loadjs.ready(
                  url + "?v=" + localStorage["languageVersion"],
                  () => callback(rs, url)
                )
              : loadjs(
                  [url + "?v=" + localStorage["languageVersion"]],
                  url + "?v=" + localStorage["languageVersion"],
                  {
                    success: () => {
                      callback(rs, url);
                    },
                    error: () => {
                      console && console.warn("load " + url + " fail");
                      callback(rs, url);
                    }
                  }
                );
          });
    } else {
      !mod
        ? rs()
        : callApi("/api/ec/dev/locale/getLabelByModule", "GET", {
            moduleCode: `${mod}`
          }).then(result => {
            const { datas, language } = result;
            window[localeKey].userLanguage = language;
            if (Array.isArray(datas)) {
              datas.forEach(item => {
                if (!window[localeKey][item.type]) {
                  window[localeKey][item.type] = {};
                }
                window[localeKey][item.type][item.id] = item.label;
              });
            }
            window[localeKey].loadedModules = window[
              localeKey
            ].loadedModules.concat(mod);
            window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
            rs();
          });
    }
  });

// 用于写在 React-Router 的 onEnter 中
const getLocaleLabel = (moduleCode, nextState, replace, callback) => {
  const callbackFunction = typeof callback === "function";
  if (!callbackFunction) {
    console && console.log("on enter router callback not function");
  }
  // check sso
  if (!window.ssoChecked) {
    checkSSO().then(() => {
      if (
        !/.*appid=.*&service=.*/.test(window.location.href) &&
        !window.loadCas
      ) {
        // window.loadCas = true;
        callApi("/api/integration/common1/checkCasIsDeployed", "POST", {}).then(
          res => {
            if (
              !res.hasSession &&
              res.isDeployed &&
              res.weaver_login_type !== "OALogin"
            ) {
              let servicePath =
                window.location.pathname +
                window.location.search +
                window.location.hash;
              if (/\/wui\/index\.html\#\/\?/.test(servicePath)) {
                servicePath =
                  (window.ecologyContentPath || "") + "/wui/index.html#/main";
              }
              if (
                /\/spa\/portal\/public\/index\.html#\/licensesubmit\?display=page/.test(
                  window.location.href
                )
              ) {
                getOs(() => {
                  getLocaleLabelInner(moduleCode, nextState, replace, callback);
                });
              } else {
                function getQueryVariable(variable) {
                  var query = window.location.search.substring(1);
                  var vars = query.split("&");
                  for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    if (pair[0] == variable) {
                      return pair[1];
                    }
                  }
                  return false;
                }
                let service =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  (window.ecologyContentPath || "") +
                  "/wui/cas-entrance.jsp?path=" +
                  encodeURIComponent(servicePath) +
                  `&ssoType=${res.ssoType}`;

                if (getQueryVariable("languid")) {
                  service =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    (window.ecologyContentPath || "") +
                    "/wui/cas-entrance.jsp?languid=" +
                    getQueryVariable("languid") +
                    "&path=" +
                    encodeURIComponent(servicePath);
                }
                window.localStorage["casPath"] = service;
                window.location.href = service;
              }
            } else {
              // sessionInitFuncs(moduleCode, nextState, replace, callback);
              getOs(() => {
                getLocaleLabelInner(moduleCode, nextState, replace, callback);
              });
            }
          }
        );
      } else {
        // sessionInitFuncs(moduleCode, nextState, replace, callback);
        getOs(() => {
          getLocaleLabelInner(moduleCode, nextState, replace, callback);
        });
      }
    });
  } else {
    getOs(() => {
      getLocaleLabelInner(moduleCode, nextState, replace, callback);
    });
  }
};

const sessionInitFuncs = (moduleCode, nextState, replace, callback) => {
  if (
    window.loadEcSessionApi !== false &&
    !/.*\/login\/OALogin\.jsp.*/.test(WindowFunc.getTop().location.href) &&
    !/.*\/wui\/index(-admin)?\.html.*#\/\?.*/.test(
      WindowFunc.getTop().location.href
    ) &&
    !/.*\/wui\/index(-admin)?\.html$/.test(WindowFunc.getTop().location.href)
  ) {
    getOs();
  }
  getLocaleLabelInner(moduleCode, nextState, replace, callback);
};

const getLocaleLabelInner = (moduleCode, nextState, replace, callback) => {
  const callbackFunction = typeof callback === "function";
  if (!callbackFunction) {
    console && console.log("on enter router callback not function");
  }
  let mod = transModeleCode(moduleCode);
  const userLanguage = getUserLanguage();
  // 如果当前缓存中没有window[localeKey] 或者 当前的语言类型发生改变,重置数据
  const noNeedTransMod =
    !window[localeKey] || userLanguage != window[localeKey].userLanguage;
  if (noNeedTransMod) {
    window[localeKey] = {
      userLanguage,
      loadedModules: [],
      reloadedModules: []
    };
    window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
    // 默认拼接上common库
    mod = mod.concat("common");
  } else {
    if (
      !window[localeKey].loadedModules ||
      !window[localeKey].loadedModules["common"]
    ) {
      mod = mod.concat("common");
    }
  }
  getLocaleLabelByCode(mod, false, noNeedTransMod).then(
    () => callbackFunction && callback()
  );
  // 加载字体大小
  if (!isInMain()) {
    if (
      localStorage["theme-themeInfo"] &&
      JSON.parse(localStorage["theme-themeInfo"])
    ) {
      let fontSize = JSON.parse(localStorage["theme-themeInfo"]).themeFontSize;
      if (fontSize) fontSize = Number(fontSize);
      if (!loadjs.isDefined(`fontSize_${fontSize}`)) {
        loadjs(
          `/cloudstore/resource/pc/com/font-size/${fontSize}px.css`,
          `fontSize_${fontSize}`
        );
      }
    }
  }
  try {
    // 加载组件库时，设置系统水印
    wm.getSystemSetting();
  } catch (error) {
    console.error(error);
  }
};

const transLang = (str, lang) => {
  //如果没有设过相应语言的翻译，返回中翻译作为默认值
  let isExsit = false,
    defaultValue = "",
    oriLang = lang;
  if (lang.length < 2) lang += " ";
  str = str.replace(constant.blank, " ");
  let from = str.indexOf(constant.LANG_CONTENT_PREFIX),
    to = str.lastIndexOf(constant.LANG_CONTENT_SUFFIX);
  if (from != -1 && to != -1 && from + 4 < to) {
    let ls = str.substring(from + 4, to).split(constant.LANG_CONTENT_SPLITTER1);
    for (let i = 0; i < ls.length; i++) {
      let lg = ls[i];
      if (lg.indexOf("7 ") === 0) {
        defaultValue = lg.substring(lang.length);
      }
      if (lg.indexOf(lang) === 0) {
        isExsit = true;
        return lg.substring(lang.length);
      } else if (lg.startsWith(oriLang)) {
        isExsit = true;
        return lg.substring(oriLang.length);
      }
    }
  }
  if (!isExsit) {
    return defaultValue;
  }
  return str;
};

// 解析多语言对应的显示
const formatMultiLang = str => {
  if (!str || !isString(str) || str.indexOf(constant.LANG_CONTENT_PREFIX) < 0) {
    return str;
  }
  let lang = new String(getUserLanguage());
  let arr = null;
  while ((arr = str.match(constant.langRegP))) {
    let formatValue = arr[1];
    let value = transLang(formatValue, lang);
    str = str.replace(formatValue, value);
  }
  return str;
};

class WeaLocaleProvider extends React.Component {
  static getLabel = getLabel;
  static getLocale = getLocale;
  static getUserLanguage = getUserLanguage;
  static getLocaleLabel = getLocaleLabel;
  static getLocaleLabelByCode = getLocaleLabelByCode;
  static formatMultiLang = formatMultiLang;
  static transLang = transLang;
  static getLocaleLabelByLang = getLocaleLabelByLang;
  render = () => this.props.children;
}

export default WeaLocaleProvider;



// WEBPACK FOOTER //
// ./ecology9/wea-locale-provider/index.js